import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problems() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#FF6C7F" }}>Problem</span>
            </h2>
            <p>
              Our biggest concern with iRemembered app was to make sure we offer
              users a great variety of pre-defined message templates, as well as
              include the functionality that also covers specific users who want
              to personalize their message.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/iremembered/problem_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={789}
              height={626}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problems;
